var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.685 16.203l-.024.455a.7.7 0 0 1-.736.662l-1.398-.073C7.964 16.903 2.922 11.304 3.266 4.74l.073-1.398a.7.7 0 0 1 .736-.662l2.796.146a.7.7 0 0 1 .663.736l-.147 2.796c-.02.392-.265.905-.552 1.163L5.261 8.939a10.54 10.54 0 0 0 5.3 5.885l1.559-1.404c.294-.265.83-.455 1.214-.434l2.81.147a.7.7 0 0 1 .656.735l-.123 2.342.008-.007z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.3bd2dc9bd47ade80bb2194f3bcb30e79.svg";
export { ForwardRef as ReactComponent };